import { createIdentifier } from '@blocksuite/global/di';

/** Semantic history for managed stores; ordinary page stores keep Yjs history. */
export interface StoreHistoryOverride {
  readonly canUndo: boolean;
  readonly canRedo: boolean;
  undo(): Promise<unknown>;
  redo(): Promise<unknown>;
  captureSync(): void;
}

export const StoreHistoryOverride = createIdentifier<StoreHistoryOverride>(
  'StoreHistoryOverride'
);
